import { Image } from "antd";
import { convertS3UrlToGcp } from "../../../edit_enhanced/helpers";

export const renderCover = ({ record }: any) =>
    record?.banner ? (
        <Image src={convertS3UrlToGcp(record?.banner)} width={70} />
    ) : (
        "no cover"
    );
